import styled from "styled-components"

export const StyledContainer = styled.div`
  height: 100%;
  background-size: cover;
  background: url("/assets/loginBackground.png") fixed bottom;
  
  img {
    width: 160px;
    display: block;
    margin: 25px auto 
  }

  .login__Row--fullHeight {
    height: 100%;
  }

  .ant-typography {
    text-align: center;
  }

  span {
    color: white;
    text-align: center; 
  }

  .ant-form {
    width: 80%;
    margin: 0 auto; 
  }

  .ant-form .ant-btn {
    width: 100%;
  }

  .ant-form small {
    color: white;
  }
`
